export default __webpack_public_path__ + "reports/output/index.html";